import { render, staticRenderFns } from "./Jingqi.vue?vue&type=template&id=1b3be126&scoped=true&"
import script from "./Jingqi.vue?vue&type=script&lang=js&"
export * from "./Jingqi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3be126",
  null
  
)

export default component.exports